import { Entity } from '..'

export class EnablementTaskCategory extends Entity {
  name: string;
  config: Record<string, any>;

  toString () {
    return this.name
  }
}
